import { cva } from 'class-variance-authority';

import s from './SelectDayButton.module.css';

export const buttonVariants = cva(s.button, {
  defaultVariants: {
    active: false,
    highlight: false,
    past: false,
    size: 'base',
    variant: 'weekday',
  },
  variants: {
    active: {
      true: s.button_active,
    },
    highlight: {
      true: null,
    },
    past: {
      true: s.button_past,
    },
    size: {
      base: s.button_s_base,
      lg: s.button_s_lg,
    },
    variant: {
      weekday: null,
      weekend: s.button_v_weekend,
    },
  },
});

export const dayVariants = cva(s.day, {
  defaultVariants: {
    active: false,
    past: false,
    variant: 'weekday',
  },
  variants: {
    active: {
      true: s.day_active,
    },
    past: {
      true: s.day_past,
    },
    variant: {
      weekday: s.day_v_weekday,
      weekend: s.day_v_weekend,
    },
  },
});

export const dateVariants = cva(s.date, {
  defaultVariants: {
    highlight: false,
  },
  variants: {
    highlight: {
      true: s.date_highlight,
    },
  },
});
